import { format } from 'date-fns'
import { type Ref, ref } from 'vue'

import type { DashboardFilters, DashboardWidget, NumberOfOrdersPerImpositionRow } from './types'

export function createDashboardState(): {
    dashboardSections: Ref<unknown[]>
    dashboardItems: Ref<DashboardWidget[]>
    filters: Ref<DashboardFilters>
    paperNeeded: Ref<unknown[]>
    paperNeededLoading: Ref<boolean>
    ordersProcesses: Ref<unknown[]>
    ordersProcessesLoading: Ref<boolean>
    processedOrders: Ref<unknown[]>
    processedOrdersLoading: Ref<boolean>
    newOrders: Ref<unknown[]>
    newOrdersLoading: Ref<boolean>
    numberOfOrdersPerImposition: Ref<NumberOfOrdersPerImpositionRow[]>
    userTasks: Ref<unknown[]>
    userTasksLoading: Ref<boolean>
    ordersProductsPerDayNotSent: Ref<unknown[]>
    ordersProductsDelayed: Ref<unknown[]>
    pagination: Ref<Record<string, unknown>>
    paginationSettings: Ref<Record<string, unknown>>
    setInitialFilters: () => DashboardFilters
} {
    function getInitialFilters(): DashboardFilters {
        return {
            checkDate__gte: format(new Date(), 'yyyy-MM-dd'),
            checkDate__lte: format(new Date(), 'yyyy-MM-dd'),
            productionDepartment_id: null
        }
    }

    const filters = ref<DashboardFilters>(getInitialFilters())

    return {
        dashboardSections: ref<unknown[]>([]),
        dashboardItems: ref<DashboardWidget[]>([]),
        filters,
        paperNeeded: ref<unknown[]>([]),
        paperNeededLoading: ref(false),
        ordersProcesses: ref<unknown[]>([]),
        ordersProcessesLoading: ref(false),
        processedOrders: ref<unknown[]>([]),
        processedOrdersLoading: ref(false),
        newOrders: ref<unknown[]>([]),
        newOrdersLoading: ref(false),
        numberOfOrdersPerImposition: ref<NumberOfOrdersPerImpositionRow[]>([]),
        userTasks: ref<unknown[]>([]),
        userTasksLoading: ref(false),
        ordersProductsPerDayNotSent: ref<unknown[]>([]),
        ordersProductsDelayed: ref<unknown[]>([]),
        pagination: ref<Record<string, unknown>>({}),
        paginationSettings: ref<Record<string, unknown>>({}),
        setInitialFilters: () => {
            filters.value = getInitialFilters()
            return filters.value
        }
    }
}

export type DashboardState = ReturnType<typeof createDashboardState>
